
export const NA = "n/a" as const;
export type TNA = typeof NA;

// Risk Ranks
export const RiskRanks = ["negligible", "low", "moderate", "high", "critical"] as const;
export const RiskRanksWithNA = [...RiskRanks, NA] as const;
export type TRiskRank = (typeof RiskRanks)[number];
export type TRiskRankWithNA = (typeof RiskRanksWithNA)[number];

// Frequency / Likelihood 
export const RiskFrequencies = ["almost_never", "infrequent", "occasional", "frequent", "almost_always"] as const;
export const RiskFrequenciesWithNA = [...RiskFrequencies, NA] as const;
export type TRiskFrequency = (typeof RiskFrequencies)[number];
export type TRiskFrequencyWithNA = (typeof RiskFrequenciesWithNA)[number];


// Severity
export const RiskSeverities = ["negligible", "minor", "moderate", "major", "catastrophic"] as const;
export const RiskSeveritiesWithNA = [...RiskSeverities, NA] as const;
export type TRiskSeverity = (typeof RiskSeverities)[number];
export type TRiskSeverityWithNA = (typeof RiskSeveritiesWithNA)[number];

export function toRankIdx( r: TRiskFrequency | TRiskSeverity | TNA | TRiskRank): number {
  switch( r ){
      case "n/a": return 0;

      case "negligible":
      case "almost_never": return 1;
      
      case "low":
      case "minor":
      case "infrequent": return 2;
      
      case "moderate":
      case "occasional": return 3;
      
      case "high":
      case "major":
      case "frequent": return 4;
      
      case "critical":
      case "catastrophic":
      case "almost_always": return 5;
      
      default: return 0;
  }

}